import { render, staticRenderFns } from "./BasePropertyIconItem.vue?vue&type=template&id=5aad2e8b&"
import script from "./BasePropertyIconItem.vue?vue&type=script&lang=js&"
export * from "./BasePropertyIconItem.vue?vue&type=script&lang=js&"
import style0 from "./BasePropertyIconItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports